/** @format */
import {RefObject, useCallback, useEffect, useRef, useState} from 'react';

interface ScrollingReturn<T> {
  isScrolling: boolean;
  scrollerRef: RefObject<T>;
  checkScrolling: () => void;
}

/**
 * Поможет определить, скроллится контент или нет.
 */

const useIsScrolling = <T extends HTMLElement>(): ScrollingReturn<T> => {
  const [isScrolling, setIsScrolling] = useState<boolean>(false);

  const scrollerRef = useRef<T>(null);

  const checkScrolling = useCallback(() => {
    const el = scrollerRef.current;
    if (!el) return;

    setIsScrolling(el.scrollWidth > el.clientWidth);
  }, []);

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;

    checkScrolling();

    const resizeObserver = new ResizeObserver(checkScrolling);
    resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, [checkScrolling]);

  return {
    isScrolling,
    scrollerRef,
    checkScrolling,
  };
};

export {useIsScrolling};
